/**
 * GeChiUI dependencies
 */
import { Button, Tooltip } from '@gechiui/components';
import { link, linkOff } from '@gechiui/icons';
import { __ } from '@gechiui/i18n';

export default function LinkedButton( { isLinked, ...props } ) {
	const label = isLinked ? __( 'Unlink Radii' ) : __( 'Link Radii' );

	return (
		<Tooltip text={ label }>
			<Button
				{ ...props }
				className="component-border-radius-control__linked-button"
				isPrimary={ isLinked }
				isSecondary={ ! isLinked }
				isSmall
				icon={ isLinked ? link : linkOff }
				iconSize={ 16 }
				aria-label={ label }
			/>
		</Tooltip>
	);
}
